module.exports = __webpack_public_path__ + "static/media/IMG_3925.e02d81e5.JPG";